import { ArticleAttributes } from '@/types/articleTypes';

export default function generateBlogPostingSchema(
	schemaData: ArticleAttributes,
) {
	let authorName = schemaData.updatedBy?.firstname
		? `${schemaData.updatedBy?.firstname} ${schemaData.updatedBy?.lastname}`
		: `${schemaData.createdBy?.firstname} ${schemaData.createdBy?.lastname}`;

	if (
		schemaData.createdBy?.firstname == 'Jessica' &&
		!schemaData.updatedBy?.firstname
	) {
		authorName = 'hvac.com';
	}

	return {
		'@context': 'https://schema.org',
		'@type': 'BlogPosting',
		mainEntityOfPage: {
			'@type': 'WebPage',
			'@id': `https://www.hvac.com/expert-advice/${schemaData.slug}`,
		},
		headline: `${schemaData.title}`,
		description: `${schemaData.seo.metaDescription}`,
		author: {
			'@type': 'Person',
			name: `${authorName}`,
		},
		publisher: {
			'@type': 'Organization',
			name: 'https://www.hvac.com/',
			logo: {
				'@type': 'ImageObject',
				url: 'https://www.hvac.com/img/icons/hvac-logo.svg',
			},
		},
		datePublished: `${schemaData.publishedAt}`,
		dateModified: `${schemaData.updatedAt}`,
	};
}
